import React from 'react';
import { ImageCollage } from '@naf-simba/sections-image-collage';
import { isNonNullable } from '@lib/isNonNullable';
import { CloudinaryImageType } from '@appTypes/CloudinaryImageType';
import { useCloudinary } from '@hooks/Cloudinary/useCloudinary';
import * as S from './BlockImageCollage.styles';

interface Props {
  images?: CloudinaryImageType[];
}
const BlockImageCollage = ({ images }: Props) => {
  const { getProcessedImage } = useCloudinary();

  const mappedImages = images
    ?.map((image: CloudinaryImageType, index: number) => {
      const imageHeight = index === 0 ? 530 : 260;
      const cloudinaryImageSrc = getProcessedImage(image?.publicId || image?.public_id, {
        height: imageHeight,
        focusMethod: image?.focus,
      })?.toURL();

      if (cloudinaryImageSrc) {
        return {
          src: cloudinaryImageSrc,
          description: image.caption ? image.caption : '',
          altText: image.altText || '',
        };
      }
      return null;
    })
    .filter(isNonNullable);

  return (
    <S.ImageCollageWrapper className="BlockImageCollage">
      <ImageCollage images={mappedImages} />
    </S.ImageCollageWrapper>
  );
};

export default BlockImageCollage;
